<template>
  <v-card
    class="partner-popup"
    :class="{ 'partner-popup--mobile': mobile }"
    :width="mobile ? 360 : 700"
    flat
    tile
  >
    <v-btn
      v-if="showClose"
      class="partner-popup__close"
      icon
      small
      aria-label="Close"
      data-qa="partner-popup-close"
      @click="$emit('close')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-img
      :src="image"
      :alt="heading"
      :height="mobile ? 360 : 300"
      class="grey lighten-3"
    >
      <template #placeholder>
        <div class="d-flex fill-height align-center justify-center text--secondary">
          Image area
        </div>
      </template>
    </v-img>

    <v-card-text class="text-center pt-3 pb-6 px-6">
      <div
        v-if="showTrustedPartner"
        class="partner-popup__trusted text-caption font-weight-bold
               primary-grey--text d-flex align-center mb-2"
      >
        <img
          :src="grainFoxLogo"
          alt="GrainFox"
          height="17"
          class="mr-1"
        >
        <span class="mt-1">Trusted Partner</span>
      </div>

      <h2 class="partner-popup__heading font-weight-bold primary-grey--text">
        {{ heading }}
      </h2>
      <p class="partner-popup__subheading font-weight-bold primary-grey--text mb-2">
        {{ subheading }}
      </p>
      <p
        class="partner-popup__copy primary-grey--text mb-0"
        :class="mobile ? 'text-body-2' : 'text-body-1'"
      >
        {{ body }}
      </p>

      <v-btn
        v-if="ctaLabel"
        class="partner-popup__cta mt-6 text-none font-weight-bold white--text"
        depressed
        rounded
        :height="mobile ? 36 : 47"
        :block="mobile"
        data-qa="partner-popup-cta"
        @click="$emit('cta')"
      >
        {{ ctaLabel }}
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import grainFoxLogo from '@/assets/images/grainfox-logo-black.svg?url';

export default {
  name: 'PartnerPopupCard',

  props: {
    heading: { type: String, default: '' },
    subheading: { type: String, default: '' },
    body: { type: String, default: '' },
    ctaLabel: { type: String, default: '' },
    image: { type: String, default: '' },
    showTrustedPartner: { type: Boolean, default: true },
    mobile: { type: Boolean, default: false },
    showClose: { type: Boolean, default: true },
  },

  data() {
    return {
      grainFoxLogo,
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/colors/colors";

.partner-popup {
  position: relative;
  max-width: 100%;

  &__close {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
  }

  &__heading {
    font-size: 20px;
    line-height: 1.3;
  }

  &__subheading {
    font-size: 18px;
  }

  &__cta {
    background-color: colors.$brandTeal !important;
    font-size: 18px;
    letter-spacing: normal;
  }

  &--mobile {
    .partner-popup__heading { font-size: 18px; }
    .partner-popup__subheading { font-size: 16px; }
  }
}
</style>
